"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[9016],{

/***/ 64518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ SupplyLevelChip)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_mui_chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85810);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3047);




function SupplyLevelChip({ supplyLevel, quantity }) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  if (!supplyLevel) {
    return null;
  }
  const supplyLevelToColorStyleMap = {
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.OutOfStock */ .Ne.OutOfStock]: "error",
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.NeverBeenStocked */ .Ne.NeverBeenStocked]: "darkerGrey",
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.InStockButNotAtYourLocation */ .Ne.InStockButNotAtYourLocation]: "error",
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.LowStock */ .Ne.LowStock]: "warning",
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.InStock */ .Ne.InStock]: "primary"
  };
  const supplyLevelToChipPostFixText = {
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.OutOfStock */ .Ne.OutOfStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.outOfStock",
      defaultMessage: "Out of stock"
    }),
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.NeverBeenStocked */ .Ne.NeverBeenStocked]: formatMessage({
      id: "dispense.prescription.form.sku.status.neverBeenStocked",
      defaultMessage: "Never stocked"
    }),
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.InStockButNotAtYourLocation */ .Ne.InStockButNotAtYourLocation]: formatMessage({
      id: "dispense.prescription.form.sku.status.inStockButNotAtYourLocation",
      defaultMessage: "None at your location"
    }),
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.LowStock */ .Ne.LowStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.lowStock",
      defaultMessage: "in stock"
    }),
    [elephant_web_gql__WEBPACK_IMPORTED_MODULE_2__/* .SupplyLevel.InStock */ .Ne.InStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.inStock",
      defaultMessage: "in stock"
    })
  };
  const color = supplyLevelToColorStyleMap[supplyLevel];
  const postFixText = supplyLevelToChipPostFixText[supplyLevel];
  let text = postFixText;
  if (quantity) {
    text = `${quantity} ${postFixText}`;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_chip__WEBPACK_IMPORTED_MODULE_1__/* .Chip */ .A, {
    label: text,
    color
  });
}


/***/ }),

/***/ 34651:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26298);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14187);
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99589);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76653);





const AppLayout = ({
  children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .Outlet */ .j3, null),
  bodyProps = { mainContent: void 0 },
  headerProps = {}
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(elephant_web_components__WEBPACK_IMPORTED_MODULE_1__.LayoutWithSideMenu, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
  ...headerProps
}), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Body__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
  ...bodyProps
}, children));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AppLayout);


/***/ }),

/***/ 99589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export MAIN_CONTENT_ID */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(948);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95061);
/* harmony import */ var _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10353);



const useStyles = (0,_elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .Z)((theme) => ({
  bodyContainer: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      paddingBottom: "80px"
    }
  },
  main: {
    minHeight: "max-content"
  },
  bodyRightContainer: {
    [theme.breakpoints.up("sm")]: {
      width: "96px"
    },
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-end",
      position: "fixed",
      bottom: 0,
      zIndex: 10
    },
    width: "100%"
  }
}));
const MAIN_CONTENT_ID = "ele-layout-main-content";
const Body = ({
  children,
  mainContent,
  rightContent
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    container: true,
    className: classes.bodyContainer
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    id: MAIN_CONTENT_ID,
    display: "flex",
    flex: 1,
    alignItems: "stretch",
    flexDirection: "column",
    className: classes.main
  }, mainContent != null ? mainContent : children), rightContent ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    className: classes.bodyRightContainer
  }, rightContent) : null);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Body);


/***/ }),

/***/ 14187:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Layout_Header)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.1.0_react@18.1.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(19103);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
;// CONCATENATED MODULE: ./src/client/components/Layout/Header/portals.tsx





const PORTAL_HEADER_CONTENT_ID = "portal-root-header-content";
const HeaderContentPortal = ({
  children
}) => {
  useMediaQuery(MEDIA_QUERY_SMALL_DEVICE);
  const el = document.createElement("div");
  React.useEffect(() => {
    const mount = document.getElementById(PORTAL_HEADER_CONTENT_ID);
    if (!mount) {
      return () => {
      };
    }
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el]);
  return createPortal(children, el, "key");
};
const useHeaderContentPortalContainerStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  headerContentPortal: {
    [`@media ${constants/* MEDIA_QUERY_SMALL_DEVICE */.tX}`]: {
      width: "100%",
      "&:not(:empty)": {
        marginBottom: theme.spacing(1)
      }
    }
  }
}));
const HeaderContentPortalContainer = react.memo(() => {
  const classes = useHeaderContentPortalContainerStyles();
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.headerContentPortal,
    id: PORTAL_HEADER_CONTENT_ID
  });
});

// EXTERNAL MODULE: ./src/client/common/featureFlags/FeatureFlagGuard.tsx
var FeatureFlagGuard = __webpack_require__(52937);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./src/client/utils/useTerritory.ts
var useTerritory = __webpack_require__(29346);
// EXTERNAL MODULE: ./src/client/utils/useUser.ts
var useUser = __webpack_require__(91019);
// EXTERNAL MODULE: ./src/client/components/WarningBanner/DataSyncBanner/index.tsx + 1 modules
var DataSyncBanner = __webpack_require__(77501);
// EXTERNAL MODULE: ./src/client/components/WarningBanner/AppOutOfDateBanner/index.tsx
var AppOutOfDateBanner = __webpack_require__(39632);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityContext.ts
var ObservabilityContext = __webpack_require__(50527);
;// CONCATENATED MODULE: ./src/client/components/Layout/Header/index.tsx










const Header = ({
  centerContent = /* @__PURE__ */ react.createElement(HeaderContentPortalContainer, null),
  ...props
}) => {
  const { emitAnalyticsEvent } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  const ancRegister = (0,featureFlags/* useFeatureFlag */.ye)(FeatureFlagGuard/* featureFlags.antenatalCare.actionButton */.V.antenatalCare.actionButton);
  const nigeriaDailyOutpatientRegister = (0,featureFlags/* useFeatureFlag */.ye)(
    FeatureFlagGuard/* featureFlags.registers.nigeriaDailyOutpatient */.V.registers.nigeriaDailyOutpatient
  );
  const nigeriaGeneralAttendanceRegister = (0,featureFlags/* useFeatureFlag */.ye)(
    FeatureFlagGuard/* featureFlags.registers.nigeriaGeneralAttendance */.V.registers.nigeriaGeneralAttendance
  );
  const userSettingsEnabled = (0,featureFlags/* useFeatureFlag */.ye)(FeatureFlagGuard/* featureFlags.user.whatsappConsent */.V.user.whatsappConsent);
  const flags = {
    ancRegister,
    nigeriaDailyOutpatientRegister,
    nigeriaGeneralAttendanceRegister,
    userSettingsEnabled
  };
  const user = (0,useUser/* useLazyUser */.x)();
  const territory = (0,useTerritory/* default */.Z)();
  if (!user)
    return null;
  const { roleName: userRole, facilityId, organisationId } = user;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ex_web_packages.Header, {
    ...props,
    centerContent,
    featureFlags: flags,
    userRole,
    territory,
    facilityId,
    organisationId,
    emitAnalyticsEvent
  }), /* @__PURE__ */ react.createElement(DataSyncBanner/* DataSyncBanner */.Q, {
    delay: 5e3
  }), /* @__PURE__ */ react.createElement(AppOutOfDateBanner/* AppOutOfDateBanner */.$, null));
};
/* harmony default export */ const Layout_Header = (Header);


/***/ }),

/***/ 56250:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_mui_loading_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69638);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61800);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12850);




const Loading = (props) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_loading_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    ...props
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    color: "primary"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    id: "loading.caption",
    defaultMessage: "Loading..."
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loading);


/***/ }),

/***/ 80103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* reexport safe */ _Loading__WEBPACK_IMPORTED_MODULE_0__.Z)
/* harmony export */ });
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56250);



/***/ }),

/***/ 91829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ Overlays)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _WhatsappConsentModal_WhatsAppConsentModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86889);


const Overlays = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_WhatsappConsentModal_WhatsAppConsentModal__WEBPACK_IMPORTED_MODULE_1__/* .WhatsappConsent */ .vQ, null);
};


/***/ }),

/***/ 37391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PassportView)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/client/components/Prescriptions/PrescriptionLabel.jsx
var PrescriptionLabel = __webpack_require__(79778);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./src/types/index.ts + 12 modules
var types = __webpack_require__(12823);
// EXTERNAL MODULE: ./src/client/components/Consultation/InitialForm/PrescriptionsSection/strings.ts
var strings = __webpack_require__(82690);
;// CONCATENATED MODULE: ./src/client/components/PassportView/PassportSections/Dose.tsx





const useDetailsStyles = (0,makeStyles/* default */.Z)((theme) => ({
  details: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  }
}));
const DetailWrapper = ({ children }) => {
  const classes = useDetailsStyles();
  return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.details
  }, children);
};
DetailWrapper.propTypes = {
  children: types/* ChildrenType.isRequired */.L5.isRequired
};
const DoseQuantity = ({ dose }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { doseQuantity } = dose;
  if (!doseQuantity)
    return null;
  const { unit: doseUnit } = dose.doseQuantity;
  const doseUnitMessage = strings/* doseMessages */.$C[doseUnit];
  const doseLabel = doseUnitMessage ? formatMessage(doseUnitMessage, { value: dose.doseQuantity.value }) : doseUnit;
  return /* @__PURE__ */ react.createElement(DetailWrapper, null, `${dose.doseQuantity.value} ${doseLabel}`);
};
DoseQuantity.propTypes = {
  dose: types/* DoseType.isRequired */.OM.isRequired
};
const DoseRate = ({ dose }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { rateQuantity } = dose;
  if (!rateQuantity)
    return null;
  const { value = 0, unit: rateUnit } = rateQuantity;
  const rateUnitMessage = strings/* frequencyMessages */.P2[rateUnit];
  const rateUnitLabel = rateUnitMessage ? formatMessage(rateUnitMessage, { value: 1 }) : rateUnit;
  const doseRateFrequency = formatMessage(strings/* doseRateFrequencyMsg */.g8, { value });
  return /* @__PURE__ */ react.createElement(DetailWrapper, null, `${dose.rateQuantity.value} ${doseRateFrequency} ${rateUnitLabel}`);
};
DoseRate.propTypes = {
  dose: types/* DoseType.isRequired */.OM.isRequired
};
const DoseDuration = ({ dose }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { durationQuantity } = dose;
  if (!durationQuantity)
    return null;
  const { unit: durationUnit } = durationQuantity;
  const durationUnitMessage = strings/* frequencyMessages */.P2[durationUnit];
  const durationUnitLabel = durationUnitMessage ? formatMessage(durationUnitMessage, {
    value: durationQuantity.unit
  }) : durationUnit;
  const durationMessage = formatMessage(strings/* durationQuantityMsg */.R9, {
    value: durationQuantity.value,
    unit: durationUnitLabel
  });
  return /* @__PURE__ */ react.createElement(DetailWrapper, null, durationMessage);
};
DoseDuration.propTypes = {
  dose: types/* DoseType.isRequired */.OM.isRequired
};

;// CONCATENATED MODULE: ./src/client/components/PassportView/PassportSections/Consultations.tsx






const DATE_FORMAT = "DD/MM/YYYY";
const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  hr: {
    color: "#e0e0e0",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));
const Prescription = ({
  prescription,
  date
}) => {
  const { dose } = prescription;
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(PrescriptionLabel/* default */.Z, {
    prescription
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    item: true,
    xs: 4,
    justifyContent: "flex-end"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, dayjs_min_default()(date).format(DATE_FORMAT)))), dose && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(DoseQuantity, {
    dose
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "flex-end",
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(DoseRate, {
    dose
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(DoseDuration, {
    dose
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "flex-end",
    item: true,
    xs: 4
  }, !!dose.asNeeded && /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.passport.consultations.medication.asNeeded",
    defaultMessage: "as needed"
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement("hr", null)));
};
const Disease = ({ name, date }) => /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
  container: true
}, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
  item: true,
  xs: 8
}, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "body1"
}, name)), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
  container: true,
  justifyContent: "flex-end",
  item: true,
  xs: 4
}, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "body1"
}, dayjs_min_default()(date).format(DATE_FORMAT))), /* @__PURE__ */ react.createElement("hr", null));
const Consultations = ({
  consultations
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "space-between"
  }, consultations.length > 0 ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.title
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.passport.consultations.recentDiagnosis",
    defaultMessage: "Recent Diagnoses"
  }))), consultations.map((consultation) => {
    const { diseases = [], diagnosis = [] } = consultation;
    return [].concat(diseases).concat(diagnosis).map((d) => {
      var _a;
      return /* @__PURE__ */ react.createElement(Disease, {
        name: ((_a = d == null ? void 0 : d.codification) == null ? void 0 : _a.name) || (d == null ? void 0 : d.displayName),
        date: consultation.meta.created,
        key: `${consultation.uuid}${d.uuid}`
      });
    });
  })) : null, consultations.length > 0 ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.title
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.passport.consultations.prescriptions",
    defaultMessage: "Prescriptions"
  }))), consultations.filter((c) => !!c.prescriptions).map(
    (consultation) => consultation.prescriptions.map((p) => /* @__PURE__ */ react.createElement(Prescription, {
      prescription: p,
      date: consultation.meta.created,
      key: `${consultation.uuid}${p.uuid}`
    }))
  )) : null);
};
/* harmony default export */ const PassportSections_Consultations = (Consultations);

;// CONCATENATED MODULE: ./src/client/components/PassportView/PassportView.tsx




const PassportComponent = (props) => {
  const { consultations } = props;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, !consultations || !consultations.length ? /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.history.passport.empty",
    defaultMessage: "Medical History Empty"
  }))) : null, consultations.length ? /* @__PURE__ */ react.createElement(PassportSections_Consultations, {
    consultations: consultations.sort((a, b) => {
      const dateA = new Date(a.meta.created);
      const dateB = new Date(b.meta.created);
      return dateB.getTime() - dateA.getTime();
    })
  }) : null);
};
/* harmony default export */ const PassportView = (react.memo(PassportComponent));


/***/ }),

/***/ 39551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HG": () => (/* binding */ GetPatientConsultationsDocument),
/* harmony export */   "cN": () => (/* binding */ PatientConsultationFragmentFragmentDoc),
/* harmony export */   "h6": () => (/* binding */ useGetPatientConsultationsQuery)
/* harmony export */ });
/* unused harmony export useGetPatientConsultationsLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24520);
/* harmony import */ var _clinical_engine_consultation_data_sync_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40305);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41552);



const defaultOptions = {};
const PatientConsultationFragmentFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
    fragment PatientConsultationFragment on Consultation {
  id
  uuid
  clinic
  unit
  clinician
  problem
  presentingComplaint
  location {
    name
  }
  diagnoses {
    id
    code
    codification {
      name
      category
    }
    severity
    note
    onsetDateTime
    uuid
  }
  diseases {
    ...DiseaseDetails
  }
  plan
  patient
  meta {
    created
    active
    persistedAt
  }
  deliveredBy {
    ...UserDetails
  }
  prescriptions {
    ...OutpatientPrescriptionFragment
  }
}
    ${_clinical_engine_consultation_data_sync_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__/* .DiseaseDetailsFragmentDoc */ .u_}
${_clinical_engine_consultation_data_sync_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__/* .UserDetailsFragmentDoc */ .Lv}
${_clinical_engine_consultation_data_sync_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__/* .OutpatientPrescriptionFragmentFragmentDoc */ .f1}`;
const GetPatientConsultationsDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
    query getPatientConsultations($patientUuid: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $patientUuid, searchWholeTerritory: $searchWholeTerritory) {
    passportId
    patient {
      uuid
      consultations {
        ...PatientConsultationFragment
      }
    }
  }
}
    ${PatientConsultationFragmentFragmentDoc}`;
function useGetPatientConsultationsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetPatientConsultationsDocument, options);
}
function useGetPatientConsultationsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetPatientConsultationsDocument, options);
}


/***/ }),

/***/ 7195:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": () => (/* reexport */ ConditionalDisplay)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/ConditionalDisplay.tsx

const ConditionalDisplay = ({
  condition = true,
  children
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, condition ? children : null);
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/index.ts



/***/ }),

/***/ 59457:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": () => (/* reexport */ EditSwitch)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/ButtonGroup/ButtonGroup.js
var ButtonGroup = __webpack_require__(69560);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/EditSwitch/EditSwitch.tsx




const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  button: {
    "&:hover": {
      backgroundColor: theme.palette.grey[400]
    }
  }
}));
const EditSwitch = ({
  editable,
  disabled,
  toggleEdit
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(ButtonGroup/* default */.Z, {
    variant: "contained",
    "aria-label": "edit mode toggle",
    disabled,
    disableFocusRipple: true,
    disableRipple: true,
    disableElevation: true
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    className: editable && classes.button,
    color: !editable ? "primary" : "default",
    onClick: () => toggleEdit(false)
  }, editable ? /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.editToggle.read",
    defaultMessage: "Read"
  }) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.editToggle.reading",
    defaultMessage: "Reading"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    className: !editable && classes.button,
    color: editable ? "primary" : "default",
    onClick: () => toggleEdit(true)
  }, editable ? /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.editToggle.editing",
    defaultMessage: "Editing"
  }) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.editToggle.edit",
    defaultMessage: "Edit"
  })));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/EditSwitch/index.ts



/***/ }),

/***/ 96224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ EnableSwitch)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52018);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12850);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69560);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61800);
/* harmony import */ var _material_ui_icons_ToggleOn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74899);
/* harmony import */ var _material_ui_icons_ToggleOff__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27022);
/* harmony import */ var _elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2550);






const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  buttonContainer: {
    alignItems: "center",
    display: "flex"
  },
  enableText: {
    fontSize: "16px"
  }
});
const EnableSwitch = ({ enabled, setEnabled }) => {
  const classes = useStyles();
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    variant: "contained",
    "aria-label": "enable mode toggle",
    disableFocusRipple: true,
    disableRipple: true,
    disableElevation: true,
    className: classes.buttonContainer
  }, enabled ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    className: classes.enableText
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: "invoicing.invoice.lineItems.enabled",
    defaultMessage: "Enabled"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__/* .IconButton */ .hU, {
    color: "primary",
    onClick: () => setEnabled(false),
    "aria-label": formatMessage({
      id: "invoicing.lineItems.disable",
      defaultMessage: "Disable lineItem"
    })
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_ToggleOn__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    fontSize: "large"
  }))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    className: classes.enableText
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: "invoicing.invoice.lineItems.disabled",
    defaultMessage: "Disabled"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__/* .IconButton */ .hU, {
    onClick: () => setEnabled(true),
    color: "grey",
    "aria-label": formatMessage({
      id: "invoicing.lineItems.enable",
      defaultMessage: "Enable lineItem"
    })
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_ToggleOff__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    fontSize: "large"
  }))));
};


/***/ })

}]);